export const enterpriseCardFeatures = [
	{
		id: 1,
		label: 'Unlimited client support'
	},
	{
		id: 2,
		label: 'Dedicated account manager'
	},
	{
		id: 3,
		label: 'Priority onboarding'
	},
	{
		id: 4,
		label: 'SLA-backed uptime'
	},
	{
		id: 5,
		label: 'Advanced analytics & reporting'
	}
]
